import {downloadFileBlob, jobDescription} from '../services/helpers'
import errorHandling from '../mixins/errorHandling'

export default {
  mixins: [errorHandling],
  data () {
    return {
      isOpen: false,
      isLoading: false,
      jobsFilesToggle: [],
      temperatureFilesToggle: [],
      jobsFilesCompensatedToggle: [],
      jobsFilesSupportVisible: [],
      jobsFilesSupportCompensatedVisible: [],
      jobsFilesPartVisible: [],
      jobsFilesPartCompensatedVisible: [],
      archivingProcess: {},
      unarchivingProcess: {},
      timers: []
    }
  },
  methods: {
    buymodal: function () {
      this.$modal.show('details')
    },
    isCost: function (outputFiles) {
      let isCost = false
      outputFiles.forEach((file) => {
        if (file.name.match(/cost.json$/) || file.name.match(/buildCostNesting.json$/)) {
          isCost = true
        }
      })
      return isCost
    },
    isNestedConfig: function (outputFiles) {
      let isNestingConfig = false
      outputFiles.forEach((file) => {
        if (file.name.match(/configNesting.json$/)) {
          isNestingConfig = true
        }
      })
      return isNestingConfig
    },
    fileDownload (event, {filename, sourceFilePathKey, jobPathKey, jobOutputPathKey, newTab}) {
      if (!this.gettingFileURL) {
        event.stopPropagation()
        const originalTitle = event.target.innerHTML
        event.target.innerHTML = 'Downloading...'
        event.target.disabled = true
        this.$store.commit('TOGGLE_GETTING_FILE_URL', true)
        return this.getDownloadURL({filename, sourceFilePathKey, jobPathKey, jobOutputPathKey})
          .then((response) => {
            if (newTab) {
              this.getURLData({url: response.data.url, blob: true})
                .then((data) => {
                  downloadFileBlob(data.data, filename)
                  event.target.innerHTML = originalTitle
                  event.target.disabled = false
                })
            } else {
              location.assign(response.data.url)
              event.target.innerHTML = originalTitle
              event.target.disabled = false
            }
            this.$store.commit('TOGGLE_GETTING_FILE_URL', false)
          })
          .catch((err) => {
            event.target.innerHTML = originalTitle
            event.target.disabled = false
            this.$store.commit('TOGGLE_GETTING_FILE_URL', false)
            console.log(err)
          })
      }
    },
    allFilesDownload (event, {list, sourceFilePathKey, jobPathKey, jobOutputPathKey, newTab}) {
      return new Promise((resolve) => {
        const downloadFile = (i) => {
          if (i === list.length) return resolve()
          this.fileDownload(event, {filename: list[i].name, sourceFilePathKey, jobPathKey, jobOutputPathKey})
            .then(() => downloadFile(i + 1))
        }
        downloadFile(0)
      })
    },
    getJobsProgress ({jobPathKey, sourceFilePathKey}) {
      return new Promise((resolve, reject) => {
        this.getJobOutputs({jobPathKey, sourceFilePathKey})
          .then((output) => {
            const jobs = output.jobOutputs
            const unfinishedJobs = this.countUnfinishedJobs(jobs)
            if (jobs && jobs.length > 0 && unfinishedJobs > 0) {
              let timerId = setTimeout(() => {
                this.getJobsProgress({jobPathKey, sourceFilePathKey})
              }, 30000)
              this.timers.push(timerId)
            } else {
              resolve()
            }
          })
          .catch((err) => {
            this.errorHandling(err, () => {
              this.getJobsProgress({jobPathKey, sourceFilePathKey})
            })
          })
      })
    },
    countUnfinishedJobs (jobs) {
      let unfinishedJobs
      if (jobs && jobs.length > 0) {
        unfinishedJobs = jobs.length
        jobs.forEach((job) => {
          if ((job.outputFiles && job.outputFiles.length > 0) || job.status === 'COMPLETE' || job.status === 'ERROR') {
            unfinishedJobs--
          }
        })
      }
      return unfinishedJobs
    },
    createJob (id, jobPathKey) {
      this.$router.push({name: 'ContinueCreateJob', params: {id, jobPathKey}})
    },
    unlockJob (event, jobOutput, job) {
      const defaultMessage = event.target.innerHTML
      event.target.innerHTML = 'Unlocking...'
      event.target.disabled = true
      this.redeemJob(jobOutput.jobOutputPathKey)
        .then(() => {
          return this.getJobOutputs({jobPathKey: job.jobPathKey, sourceFilePathKey: job.sourceFilePathKey})
        })
        .then(() => {
          return this.refreshCredits()
        })
        .catch((err) => {
          this.errorHandling(err)
          event.target.innerHTML = defaultMessage
          event.target.disabled = false
        })
    },
    removeJobConfirmation (event, sourceFilePathKey, pathKey) {
      this.$modal.show('removemodal', {
        element: event,
        sourceFilePathKey,
        pathKey
      })
    },
    resubmitJobConfirmation (event, data) {
      this.$modal.show('resubmitjobmodal', Object.assign(data, {element: event}))
    },
    displayMessage: function (status) {
      switch (status) {
        case 'PROCESSING':
          return 'Processing...'
        case 'QUEUED':
          return 'Job Queued...'
        case 'CREATED':
          return 'Job Created.'
        case 'COMPLETE':
          return 'Job Complete..'
        case 'ERROR':
          return 'Error in processing job.  Please contact support@atlas3d.xyz'
      }
    },
    jobDescription: function (analysisId, objectiveId, compensated) {
      return jobDescription(analysisId, objectiveId, compensated)
    },
    isHasOutput (filesList) {
      for (let file of filesList) {
        if (file.name.match(/(.*)_output\.stl$/) || file.name.match(/(.*)_new\.stl$/)) {
          return true
        }
      }
      return false
    },
    isHasLog (filesList) {
      for (let file of filesList) {
        if (file.name.match(/Log[_A-Za-z]*\.txt$/)) {
          return file.name
        }
      }
      return false
    },
    isHasConfigJson (filesList) {
      for (let file of filesList) {
        if (file.name.match(/^config\.json$/)) {
          return file.name
        }
      }
      return false
    },
    isHasCompensated (filesList) {
      for (let file of filesList) {
        if (file.name.match(/output_compensated\.stl$/) || file.name.match(/_compensated_0m\.stl$/)) {
          return true
        }
      }
      return false
    },
    showEstimateCost (event, {filename, sourceFilePathKey, jobPathKey, jobOutputPathKey}) {
      event.target.innerHTML = 'Estimating...'
      event.target.disabled = true
      this.getDownloadURL({filename, sourceFilePathKey, jobPathKey, jobOutputPathKey})
        .then((response) => {
          return this.getURLData({url: response.data.url})
        })
        .then((response) => {
          event.target.innerHTML = 'Estimate print costs'
          event.target.disabled = false
          this.$modal.show('estimate-cost', {data: response.data})
        })
        .catch((err) => {
          event.target.innerHTML = 'Estimate print costs'
          event.target.disabled = false
          this.errorHandling(err, () => {
            this.showEstimateCost(event, {filename, sourceFilePathKey, jobPathKey, jobOutputPathKey})
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/filesOutput.js